<template>
    <div class="gb-black c-white text-center mt20 p-r">
        <!-- 二维码 -->
        <!-- <div class="p-a irstar-qrcode pc-hidden">
            <img class="p-a dis-n qrcode" :src="'/static/img/qrcode.png'">
            <img class="wechat c-pointer" :src="'/static/img/wechat.png'">
        </div> -->
        <div class="iristar-foot fs18 lh30 pv30">
            <!-- 上部分 -->
            <div class="contact-me">
                <p v-for="i in 4" :key="`${i}_foot`">{{ $t(`foot.foot${i}`) }} </p>
            </div>

            <div class="wechat">
                <img :src="'/static/img/qrcode.png'">
            </div>

        </div>
        <div class="lh30">
            <!-- 下部分 -->
            <p>Copyright 2017-{{ year }} iristar.com.cn <a href="https://beian.miit.gov.cn/" target="_blank"
                    style="color: #fff;text-decoration: none;">津ICP备17010577号-1 津ICP备17010577号</a></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "IristarFoot",
    data() {
        return {
            year: ''
        }
    },
    mounted() {
        this.year = new Date().getFullYear()
    },

}
</script>

<style lang="less">
.wechat {
    width: 120px;
    margin: 20px auto 0;
}

@media screen and (min-width: 768px) {
    .iristar-foot {
        display: flex;
        align-content: center;
        justify-content: center;
        align-items: center;

        .wechat {
            width: 120px;
            margin: 20px 0 0 0;
        }
    }

    .contact-me {
        text-align: left;
        margin-right: 26px;
    }
}
</style>